import { DistrictIntegrations } from '@/components/admin/DistrictIntegrations';
import { CalendarSync } from '@/components/calendar/CalendarSync';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';

export default function Integrations() {
  return (
    <div className="container mx-auto py-8 px-4">
      <div className="mb-8">
        <h1 className="text-3xl font-bold">Integrations</h1>
        <p className="text-muted-foreground mt-2">
          Connect external services and sync your data
        </p>
      </div>

      <Tabs defaultValue="calendar" className="space-y-6">
        <TabsList>
          <TabsTrigger value="calendar">Calendar</TabsTrigger>
          <TabsTrigger value="communication">Communication</TabsTrigger>
        </TabsList>

        <TabsContent value="calendar">
          <CalendarSync />
        </TabsContent>

        <TabsContent value="communication">
          <DistrictIntegrations />
        </TabsContent>
      </Tabs>
    </div>
  );
}
